import { FormattedMessage } from "react-intl";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang.js";
import getYearName from "functions/getYearName.js";

function PeriodSelect({ dir, value, defaultValue, onChange, children }) {
  return (
    <div className="item-form">
      <select
        style={{ backgroundPosition: dir === "rtl" ? "4%" : "96%" }}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
      >
        {children}
      </select>
    </div>
  );
}

function PeriodOption({ value, checkedValue, name, translation, currentLocale }) {
  return (
    <option
      value={value}
      defaultChecked={value === checkedValue}
      title={LabelLangString({
        id: "name",
        currentLocale,
        defaultValue: name,
        translations: translation,
      })}
    >
      <LabelLang id="name" defaultValue={name} translations={translation} />
    </option>
  );
}

function PeriodFilters({
  dir,
  currentLocale,
  publication,
  selectYear,
  selectMonth,
  selectQuarter,
  uniqueRenderYears,
  renderedMonths,
  renderedQuarters,
  renderedHalfs,
  handleYearChange,
  setSelectMonth,
  setSelectQuarter,
}) {
  const periodicId = +publication?.periodic?.id;
  const showPeriodRow =
    periodicId === 1 ||
    periodicId === 2 ||
    periodicId === 3 ||
    periodicId === 4;

  return (
    <div
      className="box-ver-i"
      style={{ backgroundColor: "#1F254B", color: "#FFF" }}
    >
      <div className="row">
        <div className="col-lg-2">
          <h6>
            <FormattedMessage id="years" />
          </h6>
        </div>
        <PeriodSelect
          dir={dir}
          defaultValue={publication?.publicationDetail?.year}
          value={selectYear}
          onChange={(e) => handleYearChange(e.target.value)}
        >
          <option>
            [<FormattedMessage id="choose-year" />]
          </option>
          {uniqueRenderYears?.map((el, i) => (
            <option
              key={i}
              value={+el}
              defaultChecked={+el === publication?.publicationDetail?.year}
            >
              {getYearName(publication?.yearTypeId, el)}
            </option>
          ))}
        </PeriodSelect>
      </div>

      {showPeriodRow ? (
        <div className="row">
          <div className="col-lg-3">
            <h6>
              <FormattedMessage id="months/periods" />
            </h6>
          </div>
          <div className="col-lg-9" style={{ color: "#808080" }} />
        </div>
      ) : null}

      {periodicId === 1 || periodicId === 2 ? (
        <PeriodSelect
          dir={dir}
          defaultValue={publication?.publicationDetail?.month}
          value={selectMonth}
          onChange={(e) => setSelectMonth(e.target.value)}
        >
          <option value={-1}>
            [<FormattedMessage id="choose-month" />]
          </option>
          {renderedMonths.map(({ name, value, translation }, i) => (
            <PeriodOption
              key={i}
              value={value}
              checkedValue={publication?.publicationDetail?.month}
              name={name}
              translation={translation}
              currentLocale={currentLocale}
            />
          ))}
        </PeriodSelect>
      ) : null}

      {periodicId === 3 ? (
        <PeriodSelect
          dir={dir}
          defaultValue={publication?.publicationDetail?.quarter}
          value={selectQuarter}
          onChange={(e) => setSelectQuarter(e.target.value)}
        >
          <option value={-1}>
            [<FormattedMessage id="choose-quarter" />]
          </option>
          {renderedQuarters.map(({ name, value, translation }, i) => (
            <PeriodOption
              key={i}
              value={value}
              checkedValue={publication?.publicationDetail?.quarter}
              name={name}
              translation={translation}
              currentLocale={currentLocale}
            />
          ))}
        </PeriodSelect>
      ) : null}

      {periodicId === 4 ? (
        <PeriodSelect
          dir={dir}
          defaultValue={publication?.publicationDetail?.quarter}
          value={selectQuarter}
          onChange={(e) => setSelectQuarter(e.target.value)}
        >
          <option value={-1}>
            [<FormattedMessage id="choose-half" />]
          </option>
          {renderedHalfs.map(({ name, value, translation }, i) => (
            <PeriodOption
              key={i}
              value={value}
              checkedValue={publication?.publicationDetail?.half}
              name={name}
              translation={translation}
              currentLocale={currentLocale}
            />
          ))}
        </PeriodSelect>
      ) : null}
    </div>
  );
}

export default PeriodFilters;
